// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import getMenues from "../../services/Menu/getMenues";

// const initialState = {
//   menues: [],
//   validUrls: [],
//   isLoading: false,
// };

// export const BuscarMenu = createAsyncThunk(
//   "menu/buscar",
//   async (_, thunkAPI) => {
//     try {
//       const state = thunkAPI.getState();
//       const { currentUser } = state.auth;
//       if (!currentUser) {
//         return {
//           ...initialState,
//           isLoading: false,
//         };
//       }
//       const response = await getMenues();
//       if (response.error) return initialState;
//       const routes = response.flatMap((menu) =>
//         menu.child.map((child) => child.menuUrl),
//       );
//       response.find(link => link.nombre === 'Reportes').child.push({
//         "idMenu": 770,
//         "menuPosition": "95-60-00",
//         "menuUrl": "Reporte_TurnosViaje/Index",
//         "nombre": "Turnos Anticipados",
//         "menuPadre": "95-00-00",
//         "icono": "",
//         "estado": "A",
//         "creado": "2019-11-14T19:46:18.000Z",
//         "modificado": "2019-11-14T19:46:18.000Z",
//         "creadoPor": -1,
//         "modificadoPor": -1
//       }, {
//         "idMenu": 771,
//         "menuPosition": "95-70-00",
//         "menuUrl": "Reporte_InformeCumplimiento/Index",
//         "nombre": "Analytics",
//         "menuPadre": "95-00-00",
//         "icono": "",
//         "estado": "A",
//         "creado": "2019-11-14T19:46:18.000Z",
//         "modificado": "2019-11-14T19:46:18.000Z",
//         "creadoPor": -1,
//         "modificadoPor": -1
//       })
//       return {
//         menues: response,
//         validUrls: routes,
//         isLoading: false,
//       };
//     } catch (error) {
//       console.error("Error al obtener menús:", error);
//       return thunkAPI.rejectWithValue(error);
//     }
//   },
// );

// const menuSlice = createSlice({
//   name: "menu",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) =>
//     builder
//       .addCase(BuscarMenu.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(BuscarMenu.fulfilled, (state, { payload }) => {
//         state.isLoading = payload.isLoading;
//         state.menues = payload.menues;
//         state.validUrls = payload.validUrls;
//       })
//       .addCase(BuscarMenu.rejected, (state, action) => {
//         console.error("Error en la carga del menú:", action.payload);
//         state.isLoading = false;
//       }),
// });

// export default menuSlice.reducer;







import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getMenues from "../../services/Menu/getMenues";
import { logout } from "../auth/auth-slice";

const initialState = {
  menues: [],
  validUrls: [],
  isLoading: false,
};

export const BuscarMenu = createAsyncThunk(
  "menu/buscar",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const { currentUser } = state.auth;

      if (!currentUser) {
        return { ...initialState };
      }

      const response = await getMenues();
      if (response.error) return initialState;


      const routes = response?.length ? response.flatMap((menu) =>
        menu.child.map((child) => child.menuUrl),
      ) : [];

      response?.find(link => link.nombre === 'Reportes')?.child?.push({
        "idMenu": 770,
        "menuPosition": "95-60-00",
        "menuUrl": "Reporte_TurnosViaje/Index",
        "nombre": "Turnos Anticipados",
        "menuPadre": "95-00-00",
        "icono": "",
        "estado": "A",
        "creado": "2019-11-14T19:46:18.000Z",
        "modificado": "2019-11-14T19:46:18.000Z",
        "creadoPor": -1,
        "modificadoPor": -1
      }, {
        "idMenu": 771,
        "menuPosition": "95-70-00",
        "menuUrl": "Reporte_InformeCumplimiento/Index",
        "nombre": "Analytics",
        "menuPadre": "95-00-00",
        "icono": "",
        "estado": "A",
        "creado": "2019-11-14T19:46:18.000Z",
        "modificado": "2019-11-14T19:46:18.000Z",
        "creadoPor": -1,
        "modificadoPor": -1
      })

      return { menues: response, validUrls: routes, isLoading: false };
    } catch (error) {
      console.error("Error al obtener menús:", error);
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(BuscarMenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(BuscarMenu.fulfilled, (state, { payload }) => {
        state.isLoading = payload.isLoading;
        state.menues = payload.menues;
        state.validUrls = payload.validUrls;
      })
      .addCase(BuscarMenu.rejected, (state, action) => {
        console.error("Error en la carga del menú:", action.payload);
        state.isLoading = false;
      })
      .addCase(logout.fulfilled, () => initialState),
});

export default menuSlice.reducer;
